// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__dn1M9","marketplaceStroke":"IconEmailAttention_marketplaceStroke__2K7Ki","attentionStroke":"IconEmailAttention_attentionStroke__m55TU"};